import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { DuplicateOffTheShelfPartOfferPage as PartLibraryDuplicateOffTheShelfPartOfferPage } from '@/areas/offers/StandardPartOfferForm/pages/DuplicateOffTheShelfPartOfferPage';
import { canEditPartLibraryOffers } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/parts/offers/$offerId/duplicate')({
    staticData: { access: { permissions: canEditPartLibraryOffers }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <PartLibraryDuplicateOffTheShelfPartOfferPage {...pathParams} />;
}
